<template>
    <div
      class="w-100"
      v-bind:style="ParentCode.toString().length >= 3 ? 'padding: 5px 5px 5px 0px;': ''"
    >
      <table class="table table-bordered text-center table-font-size bg-white m-0">
        <!-- سربرگ جدول -->
        <thead class="text-light" v-bind:style="getColorHead">
          <td 
            colspan="5" 
            style="padding: 10px 0 !important;"
            v-bind:style="getHeaderTableFontSize"
          >
            {{getHeaderTable}}
            <span 
              title="تعداد زیر مجموعه" 
              class="mr-2"
              style="font-size: 14px !important"
              v-if="this.ParentCode.toString().length < 3"
            >
              ( <i class="fas fa-share-alt fa-rotate-90"></i>
              {{this.getListChildLastLevel(0).length}} )
            </span>
          </td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="row in getListBaseAcc">
            <tr
              :key="row.NCode"
              v-bind:id="row.NCode"
              :style="getListChildLastLevel(row.NCode).length > 0 ? 'cursor: pointer' : 'cursor: no-drop'"
              class="border-1"
              :class="{ selRow: SearchToListAllShow(row.NCode) == true }"
            >
              <!-- فلش جهت نما -->
              <td
                style="
                  width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                "
                v-on:click="SaveRowSelect(row.NCode, row.SDesc)"
              >
                <!-- منوی مشاهده فرزندان -->
                <a
                  href="#"
                  v-bind:title="'مشاهده حساب های ' + getTitleNewBaseAcc"
                  v-if="getListChildLastLevel(row.NCode).length > 0"
                >
                  <i
                    v-if="SearchToListAllShow(row.NCode) == false"
                    class="far fa-folder fa-1x-half m-1 text-primary"
                  ></i>
                  <i v-else class="far fa-folder-open fa-1x-half m-1 text-primary"></i>
                </a>
                <i v-else class="fas fa-folder-minus fa-1x-half m-1 text-primary"></i>
              </td>
              <!-- کد حساب -->
              <td
                style="
                  width: 70px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
                v-bind:style="ParentCode.toString().length < 7 ? 'font-size: 14px !important; font-weight: bold !important;': ''"
                v-on:click="SaveRowSelect(row.NCode, row.SDesc)"
              >
                {{ row.NCode }}
              </td>
              <!-- عنوان حساب -->
              <td
                style="
                  text-align: right !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding: 10px !important;
                "
                v-bind:style="ParentCode.toString().length < 7 ? 'font-size: 14px !important; font-weight: bold !important;': ''"
                v-on:click="SaveRowSelect(row.NCode, row.SDesc)"
              >
                <div
                  class="d-flex justify-content-between align-items-center w-100"
                >
                  <span>
                    {{ row.SDesc }}
                  </span>
                  <span 
                    class="text-black-50"
                    title="تعداد زیر مجموعه"
                    v-if="row.NCode.toString().length <= 7"
                  >
                    <i class="fas fa-share-alt fa-rotate-90"></i>
                    {{getListChildLastLevel(row.NCode).length}}
                  </span>
                </div>
              </td>
              <!-- نوع حساب -->
              <td>
                {{getNAccTypeName(row.NAccType)}}
              </td>
              <!-- مدیریت -->
              <td
                style="
                  width: 120px !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                "
              >
                <!-- منوی حذف سرفصل حساب -->
                <a
                  href="#"
                  title="حذف سرفصل حساب"
                  v-on:click="DeleteBaseAccRow(row)"
                  v-if="getListChildLastLevel(row.NCode).length == 0"
                >
                  <i class="far fa-trash-alt fa-1x-half m-1 text-danger"></i>
                </a>
                <i v-else style="cursor: auto; color: #d3d2d2;" class="far fa-trash-alt fa-1x-half m-1"></i>
                <!-- منوی ویرایش سرفصل حساب -->
                <a
                  href="#"
                  title="ویرایش سرفصل حساب"
                  data-toggle="modal" 
                  v-bind:data-target="'#ModalEditBaseAcc-' + row.NCode"
                  v-on:click="ShowModalEditBaseAcc(row)"
                >
                  <i class="fas fa-edit fa-1x-half m-1 text-primary"></i>
                </a>
                <!-- منوی افزودن سرفصل جدید -->
                <a
                  href="#"
                  title="افزودن سرفصل جدید"
                  data-toggle="modal" 
                  v-bind:data-target="'#ModalAddNewBaseAcc-' + row.NCode"
                  v-on:click="ShowModalAddNewBaseAcc(row.NCode, row.SDesc, row.NAccType)"
                  v-if="row.NCode.toString().length <= 7"
                >
                  <i class="far fa-clone fa-1x-half m-1 text-default"></i>
                </a>
              </td>
            </tr>
            <!-- نمایش سرفصل های فرزند به صورت فراخوانی بازگشتی -->
            <tr 
              v-if="SearchToListAllShow(row.NCode) == true && getListChildLastLevel(row.NCode).length > 0" 
              :key="'docRows' + row.NCode"
            >
              <td
                style="writing-mode: vertical-rl;
                      font-size: 14px !important;
                      padding: 10px 10px !important;"
              >{{row.SDesc}}</td>
              <td
                colspan="4"
                style="padding: 5px !important; background-color: #f1fdff"
              >
                <ShowTableBaseAcc
                  :key="row.NCode"
                  v-bind:ParentCode = "row.NCode"
                  v-bind:ListTbBaseAccData="getListAllChild(row.NCode)"
                  v-bind:isMultieSelect = "isMultieSelect"
                  v-bind:ListAllShowFilter="ListAllShowFilter"
                ></ShowTableBaseAcc>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <!-- مودال ثبت سرفصل حساب جدید -->
      <AddNewBaseAcc
        v-if="isShowAddNewBaseAccLocal == true"
        v-on:AddNewBaseAcc="HideModalAddNewBaseAcc"
        v-bind:ParentCode="SelectRowData.NCode"
        v-bind:NewChildCode="NewChildCode"
        v-bind:NewNAccType="NewNAccType"
        v-bind:Title1="'ثبت حساب ' + getTitleNewBaseAcc + ' جدید'"
        v-bind:Title2="'حساب والد : ' + SelectRowData.NCode + ' ' + SelectRowData.SDesc"
      ></AddNewBaseAcc>

      <!-- مودال ویرایش اطلاعات سرفصل حساب -->
      <EditBaseAcc
        v-if="isShowEditBaseAccLocal == true"
        v-on:EditBaseAcc="HideModalEditBaseAcc"
        v-bind:RowBaseAccData="EditTbBaseAcc"
        v-bind:Title1="'ویرایش اطلاعات حساب ' + getTitleEditBaseAcc"
        v-bind:EnableAccTypeData="getListChildLastLevel(EditTbBaseAcc.NCode).length > 0 ? false : EditTbBaseAcc.NCode.toString().length > 3 ? false : true"
      ></EditBaseAcc>

    </div>
</template>

<script>
import AddNewBaseAcc from './AddNewBaseAcc.vue';
import EditBaseAcc from './EditBaseAcc.vue'

export default {
  name: 'ShowTableBaseAcc',  // در فراخوانی بازگشتی نام باید هم نام کامپاننت باشد
  props: [
    "ParentCode", // کد حساب والد : صفر یعنی نمایش حساب های کل
    "ListTbBaseAccData", // اطلاعات ورودی به کامپاننت
    "isMultieSelect",  // کنترل وضعیت چند انتخابی
    "ListAllShowFilter"  // اطلاعات تمام سطرهای در حال نمایش
  ],
  components: {
    AddNewBaseAcc,
    EditBaseAcc
  },
  data() {
    return {
      LocalBaseAccData: [],  // لیست محلی سرفصل حساب ها
      // اطلاعات سطر در حال انتخاب
      SelectRowData: {
        NCode: 0,
        SDesc: ''
      },
      // اطلاعات تمام سطرهای در حال نمایش
      ListAllShow: [],
      // اطلاعات سرفصل حساب جهت ویرایش اطلاعات
      EditTbBaseAcc: {
        NYear: 1400, // سال
        NCode: "", // کد حساب
        SDesc: "", // شرح حساب
        NAccType: 7, // نوع حساب
        NBudget: "", // رقم بودجه
        NDebitSum: 0, // جمع بدهکار
        NCreditSum: 0, // جمع بستانکار
        NUserCode: 0, // کد کاربر ثبت کننده
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        NPerID: 0, // کد پرسنل
        NRemain1: 0, // باقیمانده 1
        NRemain2: 0, // باقیمانده 2
        NRemain3: 0,
        NRemain4: 0,
        NRemain5: 0,
        NRemain6: 0,
        NRemain7: 0,
        NRemain8: 0,
        NRemain9: 0,
        NRemain10: 0,
        NRemain11: 0,
        NRemain12: 0, // باقیمانده 12
        NBudgetCode: "", // کد بودجه
        NCreditType: 0, // نوع نوع اعتبار
        NUseType: 0, // نوع مصرف منبع
        NUseState: "", // کد ارتباط
      },
      // کنترل وضعیت نمایش مودال ثبت جدید
      isShowAddNewBaseAccLocal: false,
      // کد سطر جدید
      NewChildCode: 0,
      // کد نوع سطر جدید
      NewNAccType: 0,
      // کنترل وضعیت نمایش مودال ویرایش اطلاعات
      isShowEditBaseAccLocal: false,

    };
  },
  computed: {
    // استخراج لیست سرفصل حساب ها
    getListBaseAcc() {
      // بررسی وضعیت جستجو
      if(this.ListAllShowFilter != undefined && this.ListAllShowFilter.length > 0) {
        this.ListAllShow = this.ListAllShowFilter;
      }
      // شروع استخراج لیست سرفصل حساب ها
      let tempNCode = new String(this.ParentCode);
      if (this.ListTbBaseAccData.length > 0) {
        if (tempNCode != 0) {
          if(tempNCode.length >= 7){
            // حساب تفصیلی
            this.LocalBaseAccData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode != tempNCode &&
                item.NCode.toString().length > 7 &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          } else {
            // حساب معین 1 و معین 2
            this.LocalBaseAccData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode.toString().length == (parseInt(tempNCode.length) + 2) &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          }
        } else {
          // حساب کل
          this.LocalBaseAccData = this.ListTbBaseAccData.filter(function (item) {
            return item.NCode.toString().length == 3;
          });
        }
      }
      return this.LocalBaseAccData;
    },
    // ایجاد سایز فونت سربرگ جدول
    getHeaderTableFontSize(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'font-size: 18px !important;';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'font-size: 17px !important;';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'font-size: 16px !important;';
      } else if (this.ParentCode.toString().length >= 7 ){
        strHeader = 'font-size: 15px !important;';
      } else {
        strHeader = 'font-size: 14px !important; font-weight: bold !important;'
      }
      return strHeader;
    },    
    // ایجاد سربرگ جدول
    getHeaderTable(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'حساب های کل';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'حساب های معین 1';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'حساب های معین 2';
      } else if (this.ParentCode.toString().length >= 7 ){
        strHeader = 'حساب های تفصیلی';
      } else {
        strHeader = 'لیست حساب ها'
      }
      return strHeader;
    },
    // دریافت عنوان حساب برای درج جدید
    getTitleNewBaseAcc(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'معین 1';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'معین 2';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'تفصیلی';
      } else {
        strHeader = 'حساب'
      }
      return strHeader;
    },
    // دریافت عنوان حساب برای ویرایش
    getTitleEditBaseAcc(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'کل';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'معین 1';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'معین 2';
      } else {
        strHeader = 'تفصیلی'
      }
      return strHeader;
    },
    // ایجاد رنگ سربرگ
    getColorHead(){
      let strHeader = '';
      if(this.ParentCode.toString().length < 3){
        strHeader = 'background-color: #9933CC;';
      } else if (this.ParentCode.toString().length >= 3 && this.ParentCode.toString().length < 5){
        strHeader = 'background-color: #0277bd ';
      } else if (this.ParentCode.toString().length >= 5 && this.ParentCode.toString().length < 7){
        strHeader = 'background-color: #0288d1';
      } else if (this.ParentCode.toString().length >= 7 ){
        strHeader = 'background-color: #039be5';
      } else {
        strHeader = 'background-color: #ba68c8'
      }
      return strHeader;
    },
  },
  methods: {
    // دریافت نام نوع سرفصل حساب
    getNAccTypeName(NCode){
      return this.$store.getters.getNAccTypeName(NCode)[0].SDesc; 
    },
    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(NCode, SDesc) {
      this.SelectRowData.NCode = NCode;
      this.SelectRowData.SDesc = SDesc;
      if(this.SearchToListAllShow(NCode) == false){
        // افزودن به لیست تمام سطرهای در حال نمای
        this.SaveListAllShow(NCode);
      } else {
        // حذف از لیست تمام سطرهای در حال نمایش
        this.DeleteFromListAllShow(NCode);
      }
    },
    // نگهداری اطلاعات تمام سطرهای در حال نمایش
    SaveListAllShow(NCode){
      if(this.isMultieSelect == true){
        // مقدارد دهی به لیست
        this.ListAllShow.push(NCode);
      } else {
        // خالی کردن لیست
        this.ListAllShow.length = 0;
        // مقدار دهی به لیست
        this.ListAllShow.push(NCode);
      }
    },
    // حذف یک آیتم از لیست تمام سطرهای در حال نمایش
    DeleteFromListAllShow(NCode){
      this.ListAllShow = this.ListAllShow.filter(function(value){
        return value != NCode;
      });
    },
    // جستجو در لیست تمام سطرهای در حال نمایش
    SearchToListAllShow(NCode){
      if(this.ListAllShow.length > 0){
        let index = this.ListAllShow.findIndex(item => item == NCode);
        if(index != -1){
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // تابع نمایش مودال درج سرفصل جدید
    ShowModalAddNewBaseAcc(NCode,SDesc,NAccType){
      if(NCode != this.SelectRowData.NCode){
        this.SaveRowSelect(NCode,SDesc);
      }
      this.NewChildCode = this.getLastChildCode(NCode);
      this.NewNAccType = NAccType;
      this.isShowAddNewBaseAccLocal = true;
    },
    // تابع نمایش مودال ویرایش اطلاعات سرفصل حساب
    ShowModalEditBaseAcc(row){
      this.EditTbBaseAcc = row;
      this.isShowEditBaseAccLocal = true;
    },

    // استخراج لیست تمام فرزندان
    // جهت پاس دادن لیست تمام فرزندان به کامپاننت فرزند (فراخوانی بازگشتی)
    getListAllChild(ParentCode){
      let tempData = this.ListTbBaseAccData.filter(function (item) {
            return item.NCode.toString().length > ParentCode.length &&
            item.NCode.toString().substring(0, ParentCode.length) == ParentCode
          });
      return tempData;
    },

    // استخراج کد آخرین فرزند جهت درج سطر جدید
    getLastChildCode(NCode){
      let tempCode = 0;
      this.getListChildLastLevel(NCode).forEach(element => {
        if(element.NCode > tempCode){
          tempCode = element.NCode
        }
      });
      if(parseInt(tempCode) > 0){
        // افزایش یک واحدی کد آخرین فرزند
        return (parseInt(tempCode) + 1).toString();
      } else {
        // فرزندی یافت نشد / صدور کد جدید / تفصیلی سه صفر یک
        return (NCode + (NCode.toString().length >= 7 ? '0001' : '01')).toString();
      }
    },

    // استخراج فرزندان سطح بعدی
    // آیا گره انتخابی در سطح بعدی فرزندی دارد ؟ 
    // کنترل حذف - نمایش تعداد فرزندان - استخراج کد آخرین فرزند
    getListChildLastLevel(NCode) {
      let tempNCode = new String(NCode);
      let tempData = [];
      if (this.ListTbBaseAccData.length > 0) {
        if (tempNCode != '0') {
          if(tempNCode.length >= 7){
            // حساب تفصیلی
            tempData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode != tempNCode &&
                item.NCode.toString().length > 7 &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          } else {
            // حساب معین 1 و معین 2
            tempData = this.ListTbBaseAccData.filter(function (item) {
              return (
                item.NCode.toString().length == (parseInt(tempNCode.length) + 2) &&
                item.NCode.toString().substring(0, tempNCode.length) == tempNCode
              );
            });
          }
        } else {
          // حساب کل
          tempData = this.ListTbBaseAccData.filter(function (item) {
            return item.NCode.toString().length == 3;
          });
        }
      }
      return tempData;
    },

    // رویداد بسته شدن مودال ثبت سرفصل حساب جدید
    HideModalAddNewBaseAcc(){
        // مخفی کردن مودال ثبت سرفصل حساب جدید
        this.isShowAddNewBaseAccLocal = false;
    },

    // رویداد بسته شدن مودال ویرایش اطلاعات سرفصل حساب
    HideModalEditBaseAcc(){
      // مخفی کردن مودال ویرایش اطلاعات سرفصل حساب
      this.isShowEditBaseAccLocal = false;
    },

    // تابع حذف سرفصل حساب از لیست
    DeleteBaseAccRow(row){
      if(this.getListChildLastLevel(row.NCode).length == 0){
        swal({
          title: "تقاضای حذف سرفصل حساب",
          text: "آیا سرفصل حساب ( " + row.NCode + " - " + row.SDesc + " ) حذف شود ؟",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "انصراف",
            ok: "بله سرفصل حساب حذف شود",
          },
        }).then(async (value) => {
          if (value) {
            // نمایش لطفا صبر نمایید
            this.$store.dispatch("pleaseWait", {
              notText: "حذف سرفصل حساب از سرور",
            });
            // دریافت توکن احراز هویت
            let token = await this.$store.getters.getUserData.token;
            // ارسال تقاضای حذف سرفصل حساب به سرور
            await this.$store.dispatch("DeleteBaseAccDataToServer", {
              DeleteBaseAcc: row,
              token: token,
            });
            // لغو نمایش لطفا صبر نمایید
            this.$store.dispatch("pleaseWait", {
              stop: true,
            });
          }
        });
      } else {
        // مجاز به حذف سرفصل حساب دارای فرزند نمی باشید
        swal({
          title: "عدم حذف سرفصل حساب",
          text: "شما مجاز به حذف سرفصل حساب دارای فرزند نمی باشید .",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "بله متوجه شدم",
          },
        });
      }
    }
  }
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListBaseAcc/Components/ShowTableBaseAcc.vue